import { IChimeraApiConfigurationParams } from '@assess/browser/chimera-api';

export const chimeraApi: IChimeraApiConfigurationParams = {
  apiUrl: window.APP_CONFIG.CHIMERA_API_URL,
  appId: window.APP_CONFIG.APP_ID,
  customerId: window.APP_CONFIG.CUSTOMER_ID,
};
